import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import QuotationTool from "../views/QuotationTool.vue";
import QuotationExport from "../views/QuotationExport.vue";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "QuotationTool",
    component: QuotationTool,
  },
  {
    path: "/export/:id?",
    name: "QuotationExport",
    component: QuotationExport,
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
